<template>
  <div class="app-service-options">
    <SelectDirect
      v-if="showView"
      :options.sync="options"
      @select-option="saveOption"
      :optionLoading="optionLoading"
      :step-book-label="lblBookServiceOptions"
      :step-deactivate-label="lblDeactivateServiceOptions">
      <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SelectDirect>
    <Success
      v-if="showSuccess"
      @done="done">
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
  </div>
</template>

<script>
import SelectDirect, { stepName as viewStepName } from '../SelectDirect.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'
import Success, { stepName as successStepName } from '@/components/generic/Success.vue'

export default {
  name: 'ACROptionsWrapper',
  components: { SelectDirect, Success },
  data () {
    return {
      serviceOptions: {},
      loading: false,
      optionLoading: {
        anonymous_call_rejection: false
      },
      viewDeactivate: false
    }
  },
  mixins: [
    transaction('serviceOptions'),
    slotProxy(),
    extraData()
  ],
  props: {
    lblBookServiceOptions: {
      type: String,
      default: 'aktivieren'
    },
    lblDeactivateServiceOptions: {
      type: String,
      default: 'deaktivieren'
    }
  },
  computed: {
    showView () {
      return this.getStep() === viewStepName
    },
    showSuccess () {
      return this.getStep() === successStepName
    },
    getServiceOptions () {
      return this.extraData?.serviceOptions || []
    },
    options () {
      return (this.getServiceOptions).map(option => {
        return {
          id: option.optionId,
          name: option.name,
          price: 0,
          duration: null,
          statusKey: 'serviceKey',
          status: {
            heading: this.getStatusMessage(this.serviceOptions[option.field])
          },
          statusFlag: this.serviceOptions[option.field],
          info: option.info,
          desc: option.desc
        }
      })
    }
  },
  methods: {
    ...mapGetters('serviceOptions', [
      'getStep'
    ]),
    ...mapMutations('serviceOptions', [
      'changeStep',
      'saveServiceOptions'
    ]),
    ...mapActions('serviceOptions', [
      'saveSelectedOptions'
    ]),
    getStatusMessage (status) {
      let key = ''
      if (status) {
        key = 'active'
      } else {
        key = 'inactive'
      }
      return this.$config.serviceOptionsMap.find(item => item.key === key).message
    },
    done () {
      this.changeStep(viewStepName)
    },
    async saveOption (option) {
      this.loading = true
      this.optionLoading[option.id] = true
      option.statusFlag = !option.statusFlag
      option.status = {
        heading: this.getStatusMessage(option.statusFlag)
      }
      this.saveServiceOptions([option])
      if (!await this.saveSelectedOptions({ nextStep: successStepName })) {
        option.statusFlag = !option.statusFlag
        option.status = {
          heading: this.getStatusMessage(option.statusFlag)
        }
        this.saveServiceOptions([option])
      }
      this.$apollo.queries.serviceOptions.refresh()
      this.loading = this.optionLoading[option.id] = false
    }
  },
  apollo: {
    serviceOptions: function () {
      return wrapQuery(
        gql`query serviceOptions {
         serviceOptions {
           anonymousCallRejection
         }
        }`, this, 'serviceOptions')
    }
  }
}
</script>
